import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import VideoPlayer from './VideoPlayer';

export default function VideoCard({ video }) {
  if (!video) return null;

  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 }, borderRadius: 3, height: '100%' }}>
      <VideoPlayer video={video} />
      <Stack spacing={1} sx={{ mt: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap', gap: 0.75 }}>
          {video.category ? <Chip label={video.category} size="small" variant="outlined" /> : null}
          {video.publishedAt ? (
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {new Date(video.publishedAt).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}
            </Typography>
          ) : null}
        </Stack>
        <Typography sx={{ fontFamily: 'var(--font-serif)', fontSize: '1.25rem', lineHeight: 1.2 }}>
          {video.title}
        </Typography>
        {video.description ? (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {video.description}
          </Typography>
        ) : null}
        {video.transcript ? (
          <Box component="details" sx={{ mt: 0.5 }}>
            <Box component="summary" sx={{ cursor: 'pointer', fontSize: '0.85rem', color: 'text.secondary' }}>
              Transcript
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1, whiteSpace: 'pre-wrap' }}>
              {video.transcript}
            </Typography>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );
}
